/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCloudHealthMonitoring extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCloudHealthMonitoring");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCloudHealthMonitoring.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCloudHealthMonitoring>): BackgroundJobPayloadForCloudHealthMonitoring {
        let obj = Object.assign(new BackgroundJobPayloadForCloudHealthMonitoring(), model);
        BackgroundJobPayloadForCloudHealthMonitoring.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCloudHealthMonitoring>): BackgroundJobPayloadForCloudHealthMonitoring {
        if (!model) return null;
        return BackgroundJobPayloadForCloudHealthMonitoring.newInstance(<BackgroundJobPayloadForCloudHealthMonitoring> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCloudHealthMonitoring) {
        if (!obj) return;

        models.BackgroundJobPayloadForCloudHealthMonitoring.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCloudHealthMonitoring): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCloudHealthMonitoring.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
